import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, Boxes, MessagesSquare, ListChecks, TriangleAlert, Terminal, LogOut, Activity, BrainCircuit, UsersRound, MessageCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Tableau de bord", icon: LayoutGrid, testid: "nav-dashboard" },
  { to: "/brain", label: "Cerveau", icon: BrainCircuit, testid: "nav-brain" },
  { to: "/salon", label: "Salon", icon: MessageCircle, testid: "nav-salon" },
  { to: "/projects", label: "Projets", icon: Boxes, testid: "nav-projects" },
  { to: "/advisors", label: "Conseillers", icon: UsersRound, testid: "nav-advisors" },
  { to: "/messages", label: "Messages", icon: MessagesSquare, testid: "nav-messages" },
  { to: "/tasks", label: "Tâches", icon: ListChecks, testid: "nav-tasks" },
  { to: "/alerts", label: "Alertes", icon: TriangleAlert, testid: "nav-alerts" },
  { to: "/logs", label: "Journaux", icon: Terminal, testid: "nav-logs" },
];

export const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen bg-background">
      <aside className="fixed inset-y-0 left-0 z-20 flex w-60 flex-col border-r border-border bg-[#070707]">
        <div className="flex items-center gap-3 border-b border-border px-6 py-6">
          <Activity size={20} className="text-primary drop-shadow-[0_0_8px_rgba(0,229,255,0.6)]" />
          <div>
            <div className="font-heading text-lg font-bold tracking-[0.3em] text-white">NEXUS</div>
            <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-500">Système nerveux central</div>
          </div>
        </div>
        <nav className="flex-1 space-y-1 px-3 py-6">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 border-l-2 px-4 py-2.5 font-mono text-xs uppercase tracking-[0.15em] transition-colors duration-150 ${
                  isActive
                    ? "border-primary bg-primary/5 text-primary [text-shadow:0_0_10px_rgba(0,229,255,0.4)]"
                    : "border-transparent text-neutral-400 hover:bg-white/[0.03] hover:text-white"
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border px-4 py-4">
          <div className="mb-2 font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-600">BrainNexora</div>
          <div className="mb-3 truncate font-mono text-[10px] text-neutral-500" data-testid="admin-email">{user?.email}</div>
          <button
            data-testid="logout-button"
            onClick={handleLogout}
            className="flex w-full items-center gap-2 border border-border px-3 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-400 transition-colors duration-150 hover:border-red-500/50 hover:text-red-400"
          >
            <LogOut size={12} /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="ml-60 flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
};
